document.addEventListener('DOMContentLoaded', () => {
  onScroll();
  onClickArrowUpScroll();
  onClickHeaderBurgerMenu();
  findVideos();
  onClickAccordion();
  initModals();
  initPassShower();
});
